import React, { useEffect, useState, useRef } from "react";
import ComplaintsComponent from "./complaints";
import "./complaints.scss";
import { societyComplaint } from "../../../redux/slice/societyComplaintSlice";
import { helpDeskComplaint } from "../../../redux/slice/helpDeskComplaintSlice";
import { ticketStaus } from "../../../redux/slice/ticketStausSlice";
import { connect } from "react-redux";
import {  Tooltip, Button, Select } from "antd";
import Notify from "../../common/notify/notify";
import moment from "moment";
import PageLoader from "../../common/pageLoader";
import { dashboardSocietyCount } from "../../../redux/slice/dashboardSocietyCountSlice";
import { societyList } from "../../../redux/slice/societyListSlice";
import { InfoCircleOutlined, DownOutlined } from "@ant-design/icons";

const Complaints = (props) => {
  const {
    helpDeskComplaintData,
    callhelpDeskComplaintData,
    dashboardSocietyCountData,
    calldashboardSocietyCountData,
    callsocietyListData,
    societyListData,
    callticketStaus,
    ticketStausData,
  } = props;
  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const complaint_count =
    (dashboardSocietyCountData &&
      dashboardSocietyCountData?.dashboardSocietyCountData &&
      dashboardSocietyCountData?.dashboardSocietyCountData?.data) ||
    null;

  const helpDeskData = helpDeskComplaintData?.helpDeskComplaintData?.data?.data;

  const [complaints, setComplaints] = useState([]);

  const totalSocietyList =
    (societyListData &&
      societyListData?.societyListData &&
      societyListData?.societyListData?.data) ||
    null;

  const [complaintFilters, setComplaintFilters] = useState({
    current_status: null,
    startDate: null,
    endDate: null,
  });
  const [rangeValue, setRangeValue] = useState([null, null]);

  const prevIsLoading = useRef(false);

  useEffect(() => {
    if (prevIsLoading.current && !ticketStausData.isLoading) {
      if (ticketStausData.isError) {
        Notify(
          "error",
          "Oops! Something went wrong. Please try again later.",
          ""
        );
      } else {
        Notify(
          "success",
          "The ticket status has been updated successfully!",
          ""
        );
      }
    }
    prevIsLoading.current = ticketStausData.isLoading;
  }, [ticketStausData]);
  useEffect(() => {
    callhelpDeskComplaintData({
      startDate: null,
      endDate: null,
      current_status: null,
    });
    calldashboardSocietyCountData();
    callsocietyListData({
      type: null,
      startDate: null,
      endDate: null,
      status: null,
    });
  }, []);

  useEffect(() => {
    const styleId = "complaints-select-style";
    if (document.getElementById(styleId)) return;

    const styleElement = document.createElement("style");
    styleElement.id = styleId;
    styleElement.innerHTML = `
      .status-select .ant-select-selector {
        border: none !important;
        box-shadow: none !important;
      }
    `;
    document.head.appendChild(styleElement);

    return () => {
      const style = document.getElementById(styleId);
      if (style) {
        style.parentNode.removeChild(style);
      }
    };
  }, []);

  useEffect(() => {
    if (helpDeskData) {
      setComplaints(helpDeskData);
    }
  }, [helpDeskData]);

  const society_name = totalSocietyList?.map((item) => ({
    value: item.name,
    lable: item.name,
  }));
  const handelComplaintStatusType = (value) => {
    setComplaintFilters((prev) => ({
      ...prev,
      current_status: value,
    }));
  };
  const handelSocietyName = (value) => {
    const selected_id = totalSocietyList.find(
      (client) => client.name === value
    );
    const societyID = selected_id ? selected_id._id : null;
    setComplaintFilters((prev) => ({
      ...prev,
      societyId: societyID,
      societyName: value,
    }));
  };
  const handleFilterDateChange = (dates) => {
    setComplaintFilters((prev) => ({
      ...prev,
      startDate: dates ? dates[0].format("YYYY-MM-DD") : null,
      endDate: dates ? dates[1].format("YYYY-MM-DD") : null,
    }));
    setRangeValue(dates);
  };

  useEffect(() => {
    callhelpDeskComplaintData(complaintFilters);
  }, [complaintFilters]);

  const handleShowDetails = (record) => {
    setSelectedTicket(record);
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setSelectedTicket(null);
  };

  const handleStatusChange = (newStatus, ticketId) => {
    const updatedComplaints = complaints.map((ticket) =>
      ticket._id === ticketId
        ? { ...ticket, current_status: newStatus }
        : ticket
    );
    setComplaints(updatedComplaints);

    if (selectedTicket && selectedTicket._id === ticketId) {
      setSelectedTicket((prevTicket) => ({
        ...prevTicket,
        current_status: newStatus,
      }));
    }
    const payload = {
      id: ticketId,
      status: newStatus,
      message: `The status has been updated to ${newStatus}.`,
    };
    callticketStaus(payload);
    calldashboardSocietyCountData();
  };
  const getStatusStyle = (status) => {
    let style = {
      width: 120,
      textAlign: "center",
      borderRadius: "16px",
      padding: "2px 8px",
      fontWeight: "500",
    };
    switch (status) {
      case "pending":
        style.color = "#c62828";
        style.backgroundColor = "#ffcdd2";
        break;
      case "in-progress":
        style.color = "#0277bd";
        style.backgroundColor = "#b3e5fc";
        break;
      case "resolved":
        style.color = "#2e7d32";
        style.backgroundColor = "#e8f5e9";
        break;
      default:
        style.color = "#212121";
        style.backgroundColor = "#fafafa";
    }
    return style;
  };

  const societies_table_columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
      key: "key",
      render: (text) => <span>{text.toString().padStart(2, "0")}</span>,
    },
    {
      title: "Complaint",
      dataIndex: "content",
      key: "content",
      render: (text) => {
        const capitalizedText = text.charAt(0).toUpperCase() + text.slice(1);
        return (
          <Tooltip placement="top" title={capitalizedText}>
            <div className="complaint-container">
              <p
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "200px",
                }}
              >
                {capitalizedText}
              </p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Society Name",
      dataIndex: "societyName",
      key: "societyName",
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Priority Level",
      dataIndex: "priority",
      key: "priority",
      render: (text) =>
        text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        const statuses = ["pending", "in-progress", "resolved"];
        return (
          <Select
            className="status-select"
            value={status}
            style={getStatusStyle(status)}
            bordered={false}
            onChange={(value) => handleStatusChange(value, record.id)}
            onClick={(e) => e.stopPropagation()}
            suffixIcon={<DownOutlined style={{ fontSize: "12px", color: "#555" }} />} 
          >
            {statuses.map((s) => {
              const formattedStatus = s
                .replace(/-/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase());
    
              return (
                <Select.Option key={s} value={s}>
                  {formattedStatus}
                </Select.Option>
              );
            })}
          </Select>
        );
      },
    },
    {
      title: "Details",
      key: "actions",
      render: (text, record) => {
        return (
          <div className="edit-delete">
            <Button
              icon={<InfoCircleOutlined />}
              style={{ marginRight: 8 }}
              onClick={() => handleShowDetails(record)}
            />
          </div>
        );
      },
    },
  ];

  const filteredComplaints = complaints?.filter((item) => {
    const matchesSearchQuery = item?.title
      ?.toLowerCase()
      .includes(searchText.toLowerCase());
    return matchesSearchQuery;
  });

  const complaint_table_data = filteredComplaints?.map((item, index) => ({
    ...item,
    key: index + 1,
    id: item._id,
    content: item.title || "N/a",
    status: item.current_status,
    date: moment(item.createdAt).format("DD/MM/YYYY"),
  }));

  const handelComplaintFilterClear = () => {
    setComplaintFilters({
      current_status: null,
      startDate: null,
      endDate: null,
    });
    setSearchText("");
    setRangeValue([null, null]);
  };
  const loading = helpDeskComplaintData.isLoading;

  const isFilterApplied =
    searchText ||
    complaintFilters.current_status ||
    complaintFilters.societyName ||
    (rangeValue && (rangeValue[0] || rangeValue[1]));

  return (
    <React.Fragment>
      {loading && <PageLoader />}
      <ComplaintsComponent
        handelComplaintStatusType={handelComplaintStatusType}
        complaintFilters={complaintFilters}
        handleFilterDateChange={handleFilterDateChange}
        societies_table_columns={societies_table_columns}
        complaint_table_data={complaint_table_data}
        setSearchText={setSearchText}
        complaint_count={complaint_count}
        handelComplaintFilterClear={handelComplaintFilterClear}
        searchText={searchText}
        society_name={society_name}
        handelSocietyName={handelSocietyName}
        rangeValue={rangeValue}
        isClearButtonDisabled={!isFilterApplied}
        isModalVisible={isModalVisible}
        selectedTicket={selectedTicket}
        handleModalCancel={handleModalCancel}
        handleStatusChange={handleStatusChange}
        getStatusStyle={getStatusStyle}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  societyComplaintData: state.societyComplaintData,
  helpDeskComplaintData: state.helpDeskComplaintData,
  dashboardSocietyCountData: state.dashboardSocietyCountData,
  societyListData: state.societyListData,
  ticketStausData: state.ticketStausData,
});

const mapDispatchToProps = (dispatch) => ({
  callsocietyComplaintData: (filters) => dispatch(societyComplaint(filters)),
  callhelpDeskComplaintData: (filters) => dispatch(helpDeskComplaint(filters)),
  calldashboardSocietyCountData: () => dispatch(dashboardSocietyCount()),
  callsocietyListData: (filters) => dispatch(societyList(filters)),
  callticketStaus: (data) => dispatch(ticketStaus(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Complaints);
